import moment from "moment";
import axios from "axios";
import { isLocal } from "@/utils/env-utils";

let userEmail = "";
class SlackWebhook {
  static setUser(email) {
    userEmail = email;
  }

  static async send(message) {
    if (isLocal()) return;

    try {
      const now = moment().format("YYYY-MM-DD HH:mm:ss");

      await axios.post(`${process.env.VUE_APP_GATEWAY_HOST_URL}/t/proxy/slack`, {
        text: `[${now}] [${userEmail}]  ${message}`,
      });
    } catch (error) {
      console.log(error);
    }
  }

  // 방송중 알림. label = 펫 이름 등 식별 라벨(없으면 생략). (구: streamerAliasId)
  static async sendKey(label = "") {
    if (isLocal()) return;

    try {
      const now = moment().format("YYYY-MM-DD HH:mm:ss");
      const who = label ? ` [${label}]` : "";

      await axios.post(`${process.env.VUE_APP_GATEWAY_HOST_URL}/t/proxy/slack`, {
        text: `[${now}] [${userEmail}]${who}  OBS OnAir 방송중`,
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default SlackWebhook;
